import { render, staticRenderFns } from "./UspBadges.vue?vue&type=template&id=d15b27ca"
import script from "./UspBadges.vue?vue&type=script&lang=js"
export * from "./UspBadges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports